export const authActionTypes = {
// Authentication - login
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_USER_FAILED: 'LOGIN_USER_FAILED',
  LOGOUT_USER: 'LOGOUT_USER',
  LOADING_LOGIN_OPTIONS: 'LOADING_LOGIN_OPTIONS',
  LOAD_LOGIN_OPTIONS_SUCCESS: 'LOAD_LOGIN_OPTIONS_SUCCESS',
  LOAD_LOGIN_OPTIONS_FAILED: 'LOAD_LOGIN_OPTIONS_FAILED',
  GET_ESUOMI_AUTH_REQUEST_FAILED: 'GET_ESUOMI_AUTH_REQUEST_FAILED',
}